import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import TranslateIcon from '@mui/icons-material/Translate';
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import MicIcon from '@mui/icons-material/Mic';

import CropFreeIcon from '@mui/icons-material/CropFree';
import LayersIcon from '@mui/icons-material/Layers';
import AddchartIcon from '@mui/icons-material/Addchart';

import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import TextIncreaseIcon from '@mui/icons-material/TextIncrease';

export const editorLangEsStrs = {

    /** Updated at 01.12.2025 */
    //Hero component
    chip_label: "Nuevo: Potente Suite de Edición de Video con IA",
    main_headline_part_1: "Tu Espacio de Trabajo ",
    main_headline_part_2: "de Video en la Nube",
    main_headline_part_3: "Todo en Uno.",
    main_headline_part_4: "Edita lo que sea. Donde sea.",
    main_subtitles: "Creación avanzada de video con IA en tu navegador: convierte horizontal a vertical, edita escenas automáticamente, rastrea rostros y preserva la identidad del hablante con doblaje de IA de próxima generación.",
    feature_cards: [
        {
            icon: <AutoAwesomeIcon fontSize="large" sx={{ color: '#00BCD4' }}/>,
            title: "Generador Viral con IA",
            description: "Crea shorts virales con seguimiento facial a partir de videos largos en segundos."
          },
          {
            icon: <MicIcon fontSize="large" sx={{ color: '#9C27B0' }}/>,
            title: "Doblaje con Clonación de Voz",
            description: "Dobla en más de 40 idiomas manteniendo la identidad vocal original."
          },
          {
            icon: <TranslateIcon fontSize="large" sx={{ color: '#2196F3' }}/>,
            title: "Subtítulos Auto y Traducción",
            description: "Subtítulos con 99% de precisión y traducción instantánea."
          },
          {
            icon: <AddAPhotoIcon fontSize="large" sx={{ color: '#E91E63' }}/>,
            title: "Suite de IA Generativa",
            description: "Texto a Voz y Generación de Imágenes con IA integrados."
          }
    ],
    start_editing_button: "Empezar a Editar →",
    ai_dubbing_button: "Probar Doblaje IA (Beta)",
    workspace_preview: "Vista Previa del Espacio de Trabajo",
    //Discover
    discover_ai_shorts_features: [
        {
          icon: <CropFreeIcon fontSize="large" sx={{ color: '#00BCD4' }}/>,
          title: "Seguimiento Facial con IA",
          description: "El reencuadre inteligente mantiene al hablante perfectamente centrado en formato vertical 9:16."
        },
        {
          icon: <LayersIcon fontSize="large" sx={{ color: '#9C27B0' }}/>,
          title: "Generación por Lotes",
          description: "Sube un video de 60 minutos y obtén más de 40 shorts totalmente editados y subtitulados al instante."
        },
        {
          icon: <AddchartIcon fontSize="large" sx={{ color: '#2196F3' }} />,
          title: "Puntuación de Viralidad",
          description: "Nuestra IA clasifica los clips según el potencial de interacción para que publiques solo lo mejor."
        }
    ],
    discory_label: "⚡ EL MULTIPLICADOR DE CONTENIDO",
    discovery_left_headline_1: "Un Video Horizontal.",
    discovery_left_headline_2: "Más de 40 Shorts Virales.",
    disocry_left_headline_3: "No dejes que tu podcast o contenido de YouTube acumule polvo. Kedy.ai identifica automáticamente ganchos virales, reencuadra al hablante activo y genera clips verticales atractivos en minutos.",
    discovery_CTA_button: "Convierte 1 Video en 10 Shorts Ahora →",
    discovery_video_mockups_1: "SERIE ORIGINAL",
    discovery_video_mockups_2: "La Revolución Tecnológica",
    discovery_video_mockups_3: "T4 • E2",
    discovery_video_mockups_4: "¡ESTO ES UNA LOCURA! 🤯",

    // Other tools
    other_tools_features: [
        {
          icon: <MicIcon fontSize="large" sx={{ color: '#9C27B0' }}/>,
          title: "Clonación de Voz Real",
          description: "Analizamos tu huella vocal única para crear una versión doblada que suena exactamente como tú."
        },
        {
          icon: <ChatBubbleIcon fontSize="large" sx={{ color: '#E91E63' }}/>,
          title: "Sincronización Labial Perfecta (Beta)",
          description: "El video se ajusta sutilmente para coincidir con los movimientos labiales del nuevo idioma para una apariencia natural."
        },
        {
          icon: <TextIncreaseIcon fontSize="large" sx={{ color: '#2196F3' }}/>,
          title: "Traducción Contextual",
          description: "La jerga, modismos y términos técnicos se traducen con precisión para mantener el significado original."
        }
    ],

    other_tools_right_side_label:"🎙️ ESTUDIO DE VOZ GLOBAL",
    other_tools_headline:"Vuélvete Global.",
    speak_local:"Habla Local.",
    ai_dubbing_explanation: "Rompe las barreras del idioma sin perder tu identidad. Nuestro motor de Doblaje IA traduce tu contenido a más de 40 idiomas preservando tu voz, emoción y entonación originales.",
    other_tools_CTA_button: "Clonar Mi Voz y Doblar",
    global_reach_badge_1: "Clonación de Voz",
    global_reach_badge_2: "98% Precisión de Coincidencia",
    global_reach_badge_3: "Alcance Global",
    global_reach_badge_4: "Más de 40 Idiomas Soportados",

    // Social
    social_left_menu_badge: "INTEGRACIÓN PERFECTA",
    social_left_menu_title_1: "Conecta todo tu",
    social_left_menu_title_2: "ecosistema creativo.",
    social_left_menu_explanation: "No pierdas tiempo descargando y volviendo a subir. Kedy.ai se conecta directamente a tus plataformas favoritas para publicar con un clic y sincronizar recursos.",
    social_features: [
      {
        title: "Programación inteligente",
        desc: "Planifica con antelación. Selecciona fechas y horas específicas para que tu contenido se publique.",
        color: '#22d3ee'
      },
      {
        title: "Subida directa de video",
        desc: "Sube metraje en 4K directamente desde tu dispositivo al editor en la nube.",
        color: '#a78bfa'
      },
      {
        title: "Gestión segura de API",
        desc: "Cifrado de nivel empresarial para todas tus cuentas conectadas.",
        color: '#34d399'
      }
    ],
    social_right_menu_title: "Claves API y Conexiones",

    // Carousel
    loved_by_creators_1: "Amado por",
    loved_by_creators_2: "los creadores",
    loved_by_creators_3: "Automatizando flujos de trabajo para los mejores del sector.",
    carousel_button_1: "Empieza gratis",
    carousel_button_2: "Reserva una demo",

    /** Updated at 01.12.2025 */

    welcomNewProject : 'Bienvenido a tu nuevo proyecto',
    pls_add_media:'Por favor, añade medios a tu proyecto',
    add_video:'Añadir Video',
    add_audio:'Añadir Audio',
    add_image:'Añadir Imagen',
    add_webcam:'Captura WebCam',
    add_screen:'Captura de Pantalla',
    add_webcam_screen:'Captura WebCam & Pantalla',
    capture_screen_camera:'¡Captura tu pantalla y cámara!',
    video_captureDevice:'Dispositivo de Captura de Video',
    resolution: 'Resolución',
    audio_captureDevice: 'Dispositivo de Captura de Audio',
    resize_video: 'Redimensionar Video',
    rotate_video: 'Rotar Video',
    loop_video: 'Video en Bucle',
    joinmarge_video: 'Añadir Unir/Combinar Video',
    cut_video: 'Cortar Video',
    crop_video: 'Recortar Video',
    translate_video: 'Traducir Video',
    transcripbe_video: 'Transcribir Video',
    auto_subtitles: 'Subtítulos Automáticos',
    add_subtitle_video: 'Añadir Subtítulo al Video',
    compress_video: 'Comprimir Video',
    convert_video: 'Convertir Video',
    project_not_accessible: 'Proyecto no accesible',
    continue: 'Continuar',
    leave: 'Salir',
    cancel: 'Cancelar',
    submit: 'Enviar',
    okay: 'Ok',
    stop: 'Detener',
    record: 'Grabar',
    ongoing_upload_project_str: 'Hay una subida en curso a este proyecto.',
    leaving_page_sure: 'Estás saliendo de esta página, ¿estás seguro?',
    uploading_files: 'Subiendo Archivos',
    record_screen_and_upload: 'Graba tu pantalla y sube.',
    show_defaul_sharingMenu: 'Mostrar elementos de menú de compartir predeterminados',
    prefer_share_browser: 'Prefiere compartir una pestaña del navegador',
    prefer_share_window: 'Prefiere compartir una ventana',
    prefer_share_entireScreen: 'Prefiere compartir la pantalla entera',
    record_webcam_and_upload: 'Graba tu cámara web y sube.',
    sign_signup_to_uploadVideos: 'Por favor, inicia sesión o regístrate para subir videos',
    sizelimir_or_timelimit: 'más grande que 250 Mbytes o más largo que 5 minutos',
    screen_capture_preferences: 'Preferencias de Captura de Pantalla',
    is_uploading: 'Está Subiendo',
    monthly: 'Mensual',
    annually: 'Anualmente',
    most_popular: 'Más Popular',
    export: 'Exportar',
    bitrate: 'Tasa de Bits',
    frame_rate_fps: 'Tasa de Cuadros (FPS)',
    produce: 'Producir',
    setup: 'Configuración',
    template: 'Plantilla',
    templates: 'Plantillas',
    media: 'Medios',
    stock: 'Stock',
    translations: 'Traducciones',
    subtitles: 'Subtítulos',
    text_to_speech: 'Texto a Voz',
    transitions: 'Transiciones',
    text: 'Texto',
    emojis: 'Emojis',
    filters: 'Filtros',
    draw: 'Dibujar',
    edit_subtitle: 'Editar Subtítulo',
    add_new_subtitle: 'añadir nuevo subtítulo',
    select_brush_stock_start_draw: 'Selecciona un trazo de pincel para empezar a dibujar',
    brush_stroke: 'Trazo de Pincel',
    round: 'Redondo',
    sliced: 'Cortado',
    color: 'Color',
    opacity: 'Opacidad',
    size: 'Tamaño',
    duration: 'Duración',
    add_new_line: 'Añadir Nueva Línea',
    all_types: 'Todos los Tipos',
    load_more: 'Cargar Más',
    upload_video: 'Subir Video',
    upload_audio: 'Subir Audio',
    upload_image: 'Subir Imagen',
    create_webcam_recording: 'Crear Grabación de Webcam',
    create_screen_capture_recording: 'Crear Grabación de Captura de Pantalla',
    create_webcam_screen_recording: 'Crear Grabación de Webcam & Pantalla',
    project_asset: 'Activo del Proyecto',
    you_want_add_translations: '¿Cómo quieres añadir traducciones?',
    uploader: 'Subidor',
    auto: 'AUTO',
    auto_translations: 'Traducciones Automáticas',
    automatically_add_transllations_video: 'Añadir traducciones automáticamente al video',
    wait_moments_subtitles_being: 'Espera unos momentos mientras el subtítulo se está preparando',
    select_language_detect: 'Selecciona el idioma a detectar',
    select_different_target_language: 'Elija un idioma de destino diferente',
    select_different_source_and_target_languages: 'Los idiomas de origen y de destino no pueden ser iguales',
    voice_clones: "Clones de voz",
    source_language: "Idioma de origen",
    select_source_language: "Seleccionar idioma de origen",
    select_target_language: 'Seleccionar idioma de destino',
    redub_another_language: 'Re-Dub con otro idioma',
    upload_new_file: 'Subir Nuevo Archivo',
    no_title: 'Sin Título', 
    unknown: 'Desconocido',
    watch_video: 'Ver Video',
    listen_audio: 'Escuchar Audio',
    video_preparing: 'Preparando Video',
    audio_preparing: 'Preparando Audio',
    delete_voice_clone: 'Eliminar Clon de Voz',
    delete_voice_clone_assets: 'Eliminar Clon de Voz con Activos',
    no_voice_clones: 'No hay clones de voz para mostrar',  
    upload_file_to_create_first_voice_clone: 'Sube un archivo para crear tu primer clon de voz y romper la barrera del idioma',
    disable_translate: 'Desactivar Traducción',
    select_language_select: 'Selecciona el Idioma para traducir',
    transition_duration: 'Duración de la Transición',
    coming_soon: 'Próximamente',
    language: 'Idioma',
    english: "Inglés",
    spanish: "Español",
    french: "Francés",
    german: "Alemán",
    italian: "Italiano",
    portuguese: "Portugués",
    polish: "Polaco",
    turkish: "Turco",
    russian: "Ruso",
    dutch: "Holandés",
    czech: "Checo",
    arabic: "Árabe",
    chinese: "Chino",
    hungarian: "Húngaro",
    korean: "Coreano",
    japanese: "Japonés",
    hindi: "Hindi",
    danish: "Danés",
    greek: "Griego",
    finnish: "Finlandés",
    hebrew: "Hebreo",
    malay: "Malayo",
    norwegian: "Noruego",
    swedish: "Sueco",
    swahili: "Swahili",
    speaking_rate_defaul: 'Tasa de Habla (por defecto 1)',
    pitch_defaul: 'Tono (por defecto 0)',
    volume_gain_default: 'Ganancia de Volumen (por defecto 0)',
    create_text_speech: 'Crear Texto a Voz',
    add_text: 'Añadir Texto',
    text: 'Texto',
    start: 'Inicio',
    end: 'Fin',
    text_style: 'Estilo de Texto',
    background_color: 'Color de Fondo',
    add_new_text_field: 'Añadir Nuevo Campo de Texto',
    how_add_subtitles: '¿Cómo quieres añadir subtítulos?',
    automatically_subtitles_video: 'Añadir subtítulos automáticamente al video',
    text_color: 'Color del Texto',
    preview_text: 'Previsualizar Texto',
    search: 'Buscar',
    orientation: 'Orientación',
    next: 'Siguiente',
    previous: 'Anterior',
    first: "Primero",  
    last: "Último",
    locale: 'Localidad',
    landscape: 'Paisaje',
    portrait: 'Retrato',
    square: 'Cuadrado',
    time: 'Tiempo',
    background: 'Fondo',
    project_setting: 'Configuración del Proyecto',
    use_template_project: 'Usar como proyecto de plantilla',
    visibility: 'Visibilidad',
    category: 'Categoría',
    capture_thumbnail: 'Capturar Miniatura',
    brand_kit: 'Kit de Marca',
    video_placeholder: 'VideoPlaceholder2.mp4',
    replace_video: 'Reemplazar Video',
    transformations: 'Transformaciones',
    fill_canvas: 'Llenar el lienzo',
    fit_canvas: 'Ajustar al lienzo',
    round_corners: 'Esquinas Redondeadas',
    audio: 'Audio',
    detach_audio: 'Separar Audio',
    cleanAudio: 'AudioLimpio',
    upgrade_basic_unlock: 'Actualiza a BÁSICO para desbloquear',
    remove_background_noise_enhance_audio_qty: 'Eliminar ruido de fondo y mejorar calidad de audio',
    color_correction: 'Corrección de Color',
    reset: 'Restablecer',
    exposure: 'Exposición',
    brightness: 'Brillo',
    contract: 'Contraste',
    saturation: 'Saturación',
    sharpen: 'Afilado',
    blur: 'Desenfoque',
    noise: 'Ruido',
    trending: 'TENDENCIAS',
    custom: 'PERSONALIZADO',
    portrait: 'RETRATO',
    landscape: 'PAISAJE',
    settings: 'Configuraciones',
    magic_draw: 'Dibujo Mágico',
    tools: 'Herramientas',
    brush_size: 'Tamaño del Pincel',
    save: 'Guardar',
    clear: 'Limpiar',
    view_all: 'Ver Todo',
    save_your_project_later: 'Guarda tu proyecto para más tarde',
    sign_in: 'iniciar sesión',
    sign_up: 'registrarse',
    sign_up_home: 'Registrarse',
    redo: 'REHACER',
    undo: 'DESHACER',
    collaborate: 'COLABORAR',
    enter_email_share_project: 'Introduce el correo para compartir el proyecto',
    share_project: 'Compartir Proyecto',
    create_new_workspace: 'Crear nuevo Espacio de Trabajo',
    audio_noise_remove: 'Eliminación de Ruido de Audio',
    media_upload: 'Subida de Medios',
    draw_color: 'Color de Dibujo',
    tsl_none: 'ninguno',
    tsl_fade: 'Desvanecer',
    tsl_book_flip: 'Volteo de Libro',
    tsl_disolve: 'Disolver',
    tsl_doorway: 'Puerta',
    tsl_blur: 'Desenfocar',
    tsl_push: 'Empujar',
    tsl_slide: 'Deslizar',
    tsl_wipe: 'Limpiar',
    tsl_zoom_in: 'Acercar',
    tsl_zoom_out: 'Alejar',
    flt_None: 'Ninguno',
    flt_Darker: 'Más Oscuro',
    flt_BlacknWhite: 'Blanco y Negro',
    flt_Daphne: 'Dafne',
    flt_Penelope: 'Penélope',
    flt_Phoebe: 'Febe',
    flt_Thalia: 'Talía',
    flt_Chloe: 'Cloé',
    flt_Hermione: 'Hermione',
    flt_Hera: 'Hera',
    flt_Rhea: 'Rea',
    flt_Donna: 'Donna',
    flt_Martina: 'Martina',
    flt_Gabriella: 'Gabriella',
    flt_Elisabetta: 'Elisabetta',
    flt_Isabella: 'Isabella',
    flt_Luna: 'Luna',
    flt_Viola: 'Viola',
    flt_Zita: 'Zita',
    flt_Donata: 'Donata',
    flt_Maddalena: 'Maddalena',
    flt_Tecla: 'Tecla',
    flt_Narcisa: 'Narcisa',
    emj_Smileys: 'Sonrisas',
    emj_Animals: 'Animales',
    emj_People: 'Gente',
    emj_Jobs: 'Trabajos',
    emj_Sports: 'Deportes',
    emj_Flags: 'Banderas',
    emj_Signs: 'Señales',
    emj_Nature: 'Naturaleza',
    emj_Travel: 'Viajes',
    emj_Letters: 'Letras',
    emj_Misc: 'Varios',
    create_empty_project_templates: 'Crear un Proyecto Vacío Desde Plantillas',
    days_ago: 'hace días', 
    hours_ago: 'hace horas',
    minutes_ago: 'hace minutos',
    seconds_ago: 'hace segundos',
    create_workspace: 'Crear Espacio de Trabajo',
    workspace: 'Espacios de Trabajo',
    delete_workspace: 'Eliminar Espacio de Trabajo',
    transfer_owner: 'Transferir Propietario',
    can_create_new_workspace: '¿Podrías crear un nuevo espacio de trabajo?',
    could_delete_workspace: '¿Podrías eliminar el espacio de trabajo?',
    available_subtitles_time: 'Tiempo de Subtítulos Disponibles',
    available_storage_space: 'Espacio de Almacenamiento Disponible',
    available_subtitle_lines: 'Líneas de Subtítulos Disponibles',
    other_workspaces: 'Otros espacios de trabajo',
    members: 'Miembros',
    add_member: 'Añadir Miembro',
    remove_member: 'Eliminar Miembro',
    change_member_level: 'Cambiar Nivel de Miembro',
    owner: 'Propietario',
    admin: 'Admin',
    member: 'Miembro',
    read_only: 'Solo Lectura',
    duplicate: 'Duplicar',
    splite: 'Dividir',
    remove: 'eliminar',
    layer: 'Capa',
    volume: 'Volumen',
    disable: 'Desactivar',
    deleterow: 'EliminarFila',
    fullscreen: 'Pantalla Completa',
    editsubtitle: 'EditarSubtítulo',
    fit: 'Ajustar',
    green_screen: 'Pantalla Verde',
    profile: 'Perfil',
    contact_us: 'Contáctanos',
    pricing: 'Precios',
    login: 'Iniciar Sesión',
    logout: 'Cerrar Sesión',
    get_started_free: "Comenzar - es gratis",
    dashboard: 'Tablero',
    projects: 'Proyectos',
    menu_Features: 'Características',
    menu_Tools: 'Herramientas',
    menu_VideoEditor: 'Editor de Video',
    menu_AIVideoEditor: 'Editor de Video Basado en IA',
    menu_AddImgToVideo: 'Añadir Imagen a Video',
    menu_AddMusicToVideo: 'Añadir Música a Video',
    menu_AddTextToVideo: 'Añadir Texto a Video',
    menu_FilterVideo: 'Filtrar Video',
    menu_AddTransitionstoVideo: 'Añadir Transiciones a Video',
    menu_AddFreeStockVideos:'Añadir Videos de Stock Gratis',
    menu_SubtitlesTranscription: 'Subtítulos y Transcripción',
    menu_AddSubtitlesToVideo: 'Añadir Subtítulos a Video',
    menu_AudioToText: 'Audio a Texto',
    menu_AutoSubtitles: 'Subtítulos Automáticos',
    menu_TranscribeVideo: 'Transcribir Video',
    menu_TranslateVideo: 'Traducir Video',
    menu_Toolkit: 'Kit de Herramientas',
    menu_Crop: 'Recortar',
    menu_Cut: 'Cortar',
    menu_JoinMerge: 'Unir / Combinar',
    menu_LoopVideo: 'Video en Bucle',
    menu_Resize: 'Redimensionar',
    menu_Rotate: 'Rotar',
    menu_More: 'Más',
    menu_VideoCompressor: 'Compresor de Video',
    menu_VideoConverter: 'Conversor de Video',
    menu_AIGenerated: 'Generado por IA',
    menu_AIGeneratedImages: 'Imágenes generadas por IA',
    menu_AIGeneratedVideos: 'Vídeos generados por IA',
    menu_AIGeneratedVoices: 'Voces generadas por IA',
    menu_Blog: 'Blog',
    menu_VIDEOOBlog: 'Blog de Kedy.AI',
    menu_VIDEOOHowTo: 'Cómo hacerlo con Kedy.AI',
    menu_VIDEOOCareers: 'Carreras en Kedy.AI',
    try_autosubtitles_in_english: 'Prueba Subtítulos Automáticos en Inglés',
    try_translations_in_turkish: 'Prueba Traducciones en Turco',
    try_subtitles_in_spanish: 'Prueba Subtítulos en Español',
    try_ai_video_summary: 'Prueba Resumen de Video Basado en IA',
    online_ai_video_editor: 'Editor de Video Basado en IA en Línea',
    online_could_video_editor: 'Editor de Video Basado en la Nube en Línea',
    home_free_trial_detail: 'Prueba gratuita de 7 días, cancela en cualquier momento',
    home_create_button_detail: 'Creación de video con un clic con subtítulos automáticos, traducción y más',
    create_now: 'Crear Ahora',
    home_templates_start: 'Explora una gama de plantillas para comenzar',
    try_now_required: 'Pruébalo ahora, no se requiere cuenta',
    online_collaborative_video_editing: 'Edición de Video Colaborativa en Línea',
    online_collaborative_video_editing_detail: 'Sumérgete en el mundo de la Edición de Video en la Nube en Línea con kedy.ai. Nuestra plataforma revoluciona la forma en que editas, ofreciendo capacidades de Edición de Video Colaborativa en Línea y un Espacio de Trabajo de Edición de Video Basado en la Nube.',
    auto_subtitles_translations: 'Subtítulos Automáticos y Traducciones',
    auto_subtitles_translations_detail: "Mejora tus videos con nuestra función de Subtítulos Automáticos y Traducciones, parte de nuestro Software de Edición de Video Profesional en Línea. Diseñado para ser una Herramienta de Software de Edición de Video para Todos, kedy.ai hace que sea simple crear contenido accesible y atractivo.",
    ai_base_text_speech: 'Texto a Voz Basado en IA',
    ai_base_text_speech_detail: 'Nuestras Voces de Texto a Voz Basadas en IA son perfectas para creadores de contenido, encarnando el concepto de Edición de Video Reinventada para Youtubers e Influencers. Con kedy.ai, transforma tus guiones en locuciones atractivas, añadiendo un toque profesional a tus videos y agilizando tu proceso de producción.',
    free_user_stock_video: 'Videos de Stock Gratis para Usar',
    free_user_stock_video_detail: 'Accede a una vasta colección de Videos de Stock Gratis para Usar con kedy.ai, complementando nuestras capacidades de Edición de Video 4K en Línea. Nuestra plataforma, siendo un Software de Edición de Video 4K para Todos, asegura que tus proyectos se destaquen con metraje de alta calidad, haciendo que la edición de grado profesional sea accesible para todos los usuarios.',
    share: 'Compartir',
    unlisted_video: 'Video No Listado',
    your_video_about_ready: 'Tu video está a punto de estar listo',
    hours: 'Horas',
    minutes: 'Minutos',
    seconds: 'Segundos',
    want_free_stuff: '¿Quieres cosas gratis?',
    record_screen_webcam_both: 'Graba tu pantalla, webcam, o ambos',
    add_subtitle_your_video: 'Añade subtítulos a tus videos',
    create_your_team_workspace: 'Crea tu Espacio de Trabajo en Equipo',
    collaborate_videos: 'Colabora en videos',
    generate_transcript: 'Genera una transcripción',
    singup_get_all_this_more: 'Regístrate (gratis) para obtener todo esto y más!',
    downloading: 'Descargando',
    download: 'Descargar',
    reedit_video: 'Reeditar video',
    remove_watermark: 'Eliminar marca de agua',
    already_have_account: '¿Ya tienes una cuenta?',
    link_copied: 'Enlace Copiado',
    invitation_list: 'Lista de Invitaciones',
    remove_invitation: 'Eliminar Invitación',
    change_workspace: ' Cambiar espacio de trabajo',
    you_login_manage_your_profile: 'Necesitas iniciar sesión para gestionar tu perfil',
    you_dont_have_content_here: "No tienes ningún contenido aquí.",
    name: 'Nombre',
    status: 'Estado',
    data_modified: 'Fecha Modificada',
    all_workspaces: 'Todos los Espacios de Trabajo',
    delete_project: 'Eliminar Proyecto',
    duplicate_project: 'Duplicar Proyecto',
    draft: 'Borrador',
    edit: 'Editar',
    surname: 'Apellido',
    email: 'Correo Electrónico',
    plan: 'Plan',
    market_emails: 'Correos Electrónicos de Marketing',
    editor_notification: 'Notificaciones del Editor',
    storage: 'Almacenamiento',
    subtitle: 'Subtítulo',
    delete_account: 'Eliminar Cuenta',
    this_action_irreversibe: 'Esta acción es irreversible',
    current_plan: 'PLAN ACTUAL',
    cancel_subscription: 'Cancelar Suscripción',
    payment_method: 'MÉTODOS DE PAGO',
    expires: 'Expira',
    make_default: 'Hacer Predeterminado',
    delete: 'Eliminar',
    add_payment_method: 'Añadir método de pago',
    billing_information: 'INFORMACIÓN DE FACTURACIÓN',
    invoice_history: 'HISTORIAL DE FACTURAS',
    payment: 'Pago',
    preferences: 'Preferencias',
    save_up_to: 'Ahorra Hasta ',
    your_plan: 'Tu Plan',
    inactive: 'Inactivo',
    contact_sales: 'Contactar Ventas',
    need_additional_features: '¿Necesitas características adicionales? Pregúntanos sobre nuestro plan Empresarial',
    your_online: 'Online',
    ai_video_editor: 'Editor de Video con IA',
    one_click_post_production: 'Postproducción con un clic',
    screen_and_cam_recorder: 'Grabadora de Pantalla y Cámara',
    subtitle_translation: 'Traducción de Subtítulos',
    integrations: 'Integraciones',
    video_compressor: 'Compresor de Video',
    video_compressor_basic: 'Compresor de Video Básico',
    video_compressor_pro: 'Compresor de Video Pro',
    subtitles: 'Subtítulos',
    private_workspaces: 'Espacios de Trabajo Privados',
    share_and_embed: 'Compartir y Embeder',
    video_export_length: "Duración máxima de exportación de video",
    upload_file_size: "Tamaño máximo de archivo para subir",
    upload_file_size_tip: "El tamaño máximo de archivo que puedes subir a un proyecto",
    upload_file_size_unlimited: "Tamaño máximo de archivo para subir – ilimitado",
    export_quality_1080p: "Calidad de exportación – 1080p",
    video_export_length_tip: "La duración máxima de video que puedes exportar",
    video_export_length_free: "10 minutos",
    video_export_length_basic: "25 minutos",
    video_export_length_pro: "2 horas",
    support: 'Soporte',
    custom_templates:'Plantillas Personalizadas',
    ai_video_editor: 'Editor de Video con IA',
    one_click_post_production: 'Postproducción con un clic',
    while_pet_your_cat: 'Mientras acaricias a tu gato / tomas tu café',
    the_basics: "Lo Básico",
    no_watermark: "Sin Marca de Agua",
    pricing_compare_header: "Comparar Paquetes",
    pricing_all_plans_description:
        "Todos los planes incluyen todas las funciones de edición de video, subtítulos automáticos, proyectos ilimitados y exportaciones ilimitadas",
    pricing_apply_coupon: "Aplicar Cupón",
    pricing_faq_header: "Preguntas Frecuentes",
    tip_no_watermark: "Si el video tiene una marca de agua o no",
    video_export_length_business: "2 horas",
     workflow_tools: 'Herramientas de Flujo de Trabajo',
    audio_noise_removal: 'Eliminación de Ruido de Audio',
    video_compressor_max: 'Compresor de Video Máximo',
    corporate_add_ons: 'Complementos Corporativos',
    video_compressor_premium:'Compresor de Video Premium',
    convert_video_basic: 'Convertidor de Video Básico',
    convert_video_pro: 'Convertidor de Video Pro',
    convert_video_max: 'Convertidor de Video Máximo',
    convert_video_premium: 'Convertidor de Video Premium',
    video_player: 'Reproductor de Video',
    custom_privacy_and_security: 'Privacidad y Seguridad Personalizadas',
    while_pet_your_cat: 'Mientras acaricias a tu gato / tomas tu café',
    try_for_free: 'Probar Gratis',
    your_online_ai_video_editor: 'Tu Editor de Video con IA Online',
    discover_kedy: "¡Descubre las herramientas con IA de Kedy.AI!",
    create_video_summaries: "Crea resúmenes de video con IA",
    video_summary_description: "Kedy.AI crea secciones clave de videos largos con títulos, descripciones y descargas fáciles—rápido y sin esfuerzo.",
    ai_video_dubbing: "Elimina la barrera del idioma con doblaje por IA",
    ai_video_dubbing_description: "La herramienta de doblaje de Kedy.AI te permite hablar cualquier idioma—manteniendo tu propia voz. Solo sube el video y la IA se encarga del resto.",
    ai_shorts_reels_generator: "Generador de Shorts/Reels con IA",
    select_options_to_create_shorts: "Selecciona opciones para crear videos Shorts/Reels con IA.",
    select_ai_shorts_options: "Seleccionar opciones de Shorts con IA",
    summarize_your_content_in: "Resume tu contenido en . . .",
    set_silence_threshold: "Establecer umbral de silencio (en segundos):",
    more_chapters: "Más capítulos",
    less_chapters: "Menos capítulos",
    set_min_clip_duration: "Establecer duración mínima del clip (en segundos):",
    set_num_of_chapters: "Establecer número total de capítulos:",
    viral_clips: "Crea clips virales con el generador viral con IA para redes sociales",
    viral_clips_description: "Convierte cualquier video en clips virales llamativos con la magia de Kedy.AI—enfoque facial inteligente, subtítulos destacados y contenido listo para compartir.",
    kedy_ai_editor: "El Editor de Kedy.AI tiene todo lo que necesitas",
    kedy_offers_essential_video_editor_tools: "Kedy.AI ofrece todas las herramientas esenciales de un editor de video",
    create_project: "Crear Proyecto",
    other_ai_tools: "Otras herramientas modernas con IA",
    ai_generated_subtitles: "Subtítulos automáticos generados por IA",
    ai_translation: "Traducción con IA",
    ai_text_to_speech: "Texto a voz",
    ai_generated_images: "Imágenes generadas por IA",
    finish_post_production: "¡Finaliza tu postproducción con solo unos clics!",
    try_now: "Probar ahora"
};

